import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQProgressBar from '../../components/progress-bar';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import UQCard from '../../components/card';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'proc', type: 'number', default: '0', description: 'Current progress value (0-100).' },
  { attribute: 'color', type: 'string', default: "'primary'", description: 'Bar color or theme.' },
  { attribute: 'height', type: 'string', default: "'1rem'", description: 'Height of the progress bar.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
import UQProgressBar from '@uniqconsulting/ui/components/progress-bar';

<UQProgressBar proc={25} />
<UQProgressBar proc={50} color="success" />
<UQProgressBar proc={75} color="warning" height="0.5rem" />
<UQProgressBar proc={100} color="error" />
`;

const ProgressBarDemoPage = () => (
  <>
    <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Progress Bar']} />
    <h1>UQProgressBar Demo</h1>
    <UQSpacer size="m" />

    <h2>Description</h2>
    <p>
      <code>UQProgressBar</code> displays a horizontal progress indicator. You can control its value, color, and height.
    </p>
    <UQSpacer size="m" />

    <h2>Attributes</h2>
    <UQSpacer size="s" />
    <UQDataGrid
      items={attributes}
      columns={attributeColumns}
      sortable={false}
      selectionMode="none"
      rowLines
    />
    <UQSpacer size="m" />

    <h2>Examples</h2>
    <UQSpacer size="s" />
    <UQCard header="Progress Bar Variations">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: 300 }}>
        <UQProgressBar proc={25} />
        <UQProgressBar proc={50} color="success" />
        <UQProgressBar proc={75} color="warning" height="0.5rem" />
        <UQProgressBar proc={100} color="error" />
      </div>
    </UQCard>
    <UQSpacer size="m" />

    <h2>Code Example</h2>
    <UQCode code={codeExample.trim()} enableCopy />
  </>
);

export default ProgressBarDemoPage;